import { CommonConstants } from './../../../../common/constants/common-constants';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import { RequestsListResponse } from '../../requests/model/requestslistresponse';

@Injectable()
export class ServiceItemRelatedRequestsService {
    constructor(public http: HttpClient) { }

    // function call to fetch item related requests
    public getRelatedRequests(itemId: number, limit: number): Observable<RequestsListResponse> {
        const params = new HttpParams()
            .set('limit', limit.toString());

        return this.http.post<RequestsListResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 +
            '/customer/ci/items/' + itemId + '/relatedRequests', { params });
    }

    public getRelatedRequestsForServiceItemOutage(itemId: number, limit: number): Observable<RequestsListResponse> {
        const params = new HttpParams()
            .set('limit', limit.toString());

        return this.http.post<RequestsListResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 +
            '/customer/outages/' + itemId + '/relatedRequests', { params });
    }
}





